module.exports = __webpack_public_path__ + "img/info-ar.c3b59bb.png";


//////////////////
// WEBPACK FOOTER
// ./assets/assistant/info-ar.png
// module id = ./assets/assistant/info-ar.png
// module chunks = 10